// extracted by mini-css-extract-plugin
module.exports = {"maxBox":"maxBox___1xX1q"};